@if (isSpinning$ | async) {
    <div class="spinner" (click)="$event.stopPropagation()">
        <img class="loading" src="assets/gifs/spinner.gif" alt="Loading..."/>
    </div>
}
